<template>
  <v-row
    id="header"
    no-gutters
  >
    <v-col
      cols="12"
    >
      <div
        v-if="isProductNameDisplayed"
        :class="productNameClass"
      >
        {{ getProductName }}
      </div>
      <div
        v-if="isProductPriceDisplayed"
        :class="productPriceClass"
      >
        {{ getProductPrice }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'HeaderProduct',

    computed: {
      ...mapGetters([
        'isProductNameDisplayed',
        'isProductPriceDisplayed',
        'getHeaderAlignment',
        'getProductName',
        'getProductPrice',
      ]),

      productNameClass () {
        return 'product-name textBlack--text text-h5 text-xl-h4 font-weight-medium px-2 pt-1' + ' text-' + this.getHeaderAlignment
      },

      productPriceClass () {
        return 'product-price textGrey--text text-subtitle-2 text-sm-subtitle-1 font-weight-regular px-2 pt-1' + ' text-' + this.getHeaderAlignment
      },
    },
  }
</script>

<style scoped>
#header {
  top: 0px;
  position: absolute;
  width: 100%;
}

.product-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.product-price {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
